// Meta pixel consent wiring. Mirrors `@/integrations/tiktok/consent` but for
// `fbq`. The pixel is only injected once marketing consent is granted (see
// `MetaPixel`); this keeps the already-loaded `fbq` in sync when the visitor
// changes their mind mid-session.
//
// Scope of a revoke: `fbq('consent', 'revoke')` stops the pixel transmitting
// further events, but — unlike TikTok's `disableCookie()` — Meta exposes no way
// to drop the `_fbp` cookie it already set, so that cookie survives until it
// expires or the visitor clears it. Declining up front avoids it entirely,
// which is what the privacy policy describes.

import type { ConsentValue } from "@/features/consent/consent-storage";

type MetaPixelApi = (...args: unknown[]) => void;

function getFbq(): MetaPixelApi | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  return (window as unknown as { fbq?: MetaPixelApi }).fbq;
}

export function applyMetaConsent(value: ConsentValue): void {
  const fbq = getFbq();
  if (!fbq) {
    // Pixel not loaded yet (or never, if consent was never granted). Nothing
    // to toggle — the snippet loads in a granted state, so absence == no data.
    return;
  }
  fbq("consent", value === "granted" ? "grant" : "revoke");
}
